import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "../redux/slices/authSlice";
import { isAuthenticated } from "../utils/authUtils";

/**
 * UnprotectedRoute component - guards routes that should only be accessible when not authenticated
 * Redirects authenticated users to dashboard
 */
const UnprotectedRoute = ({ children }) => {
  const user = useSelector(selectUser);
  const location = useLocation();

  // Check if user is authenticated using utility function
  const userIsAuthenticated = isAuthenticated(user);

  // If authenticated, redirect to dashboard or intended destination
  if (userIsAuthenticated) {
    // Get the intended destination from location state, or default to dashboard
    const from = location.state?.from?.pathname || "/Dashboard";
    return <Navigate to={from} replace />;
  }

  // If not authenticated, render the unprotected component
  return children;
};

export default UnprotectedRoute;
